module.exports = __webpack_public_path__ + "72a53ee0ba53dd7b43b062341aedc9a4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/22-09-01Nagelritz-mini.jpg
// module id = 834
// module chunks = 0